import {MerchantOfRecord} from '../../api-types/bovio/response/booking'

export const getIsPayAtPropertyMoR = (offer?: {
  merchantOfRecord?: string | null
}) => offer?.merchantOfRecord === MerchantOfRecord.Hotel
